import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../Assets/LogoDPX1.png';
import './Navbar.css';

const ENLACES = [
    { to: '/', texto: 'Inicio' },
    { to: '/historia', texto: 'Historia' },
    { to: '/servicios', texto: 'Servicios' },
    { to: '/trabajos-realizados', texto: 'Trabajos' },
    { to: '/contacto', texto: 'Contacto' },
];

function Navbar() {
    const { pathname } = useLocation();
    // Guardamos la ruta en la que se abrió el menú: al cambiar de ruta se cierra solo
    const [abiertoEn, setAbiertoEn] = useState(null);
    const abierto = abiertoEn === pathname;
    const navRef = useRef(null);
    const botonRef = useRef(null);

    const cerrar = () => setAbiertoEn(null);

    // Con el menú abierto: Escape lo cierra y un clic fuera de la barra también
    useEffect(() => {
        if (!abierto) return undefined;

        const alPulsarTecla = (e) => {
            if (e.key === 'Escape') {
                setAbiertoEn(null);
                botonRef.current?.focus();
            }
        };
        const alPulsarFuera = (e) => {
            if (navRef.current && !navRef.current.contains(e.target)) setAbiertoEn(null);
        };

        document.addEventListener('keydown', alPulsarTecla);
        document.addEventListener('pointerdown', alPulsarFuera);
        return () => {
            document.removeEventListener('keydown', alPulsarTecla);
            document.removeEventListener('pointerdown', alPulsarFuera);
        };
    }, [abierto]);

    return (
        <nav className={`navbar${abierto ? ' navbar--abierta' : ''}`} ref={navRef} aria-label="Principal">
            <Link to="/" className="navbar-logo" onClick={cerrar}>
                <img src={logo} alt="DanPauleX, ir al inicio" width="194" height="50" />
            </Link>

            <button
                type="button"
                className="navbar-boton"
                ref={botonRef}
                aria-expanded={abierto}
                aria-controls="menu-principal"
                aria-label={abierto ? 'Cerrar menú' : 'Abrir menú'}
                onClick={() => setAbiertoEn(abierto ? null : pathname)}
            >
                <span className="navbar-boton-linea" aria-hidden="true" />
                <span className="navbar-boton-linea" aria-hidden="true" />
                <span className="navbar-boton-linea" aria-hidden="true" />
            </button>

            <div className="navbar-links" id="menu-principal">
                {ENLACES.map(({ to, texto }) => (
                    <NavLink key={to} to={to} end={to === '/'} onClick={cerrar}>
                        {texto}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}

export default Navbar;
